// Modals and the confirm box (prototype 05-ui.js layers(), confirmBox()), drawn into #layer.
import { type ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { L } from '../lib/prefs';
import { createStore, useStoreOf } from '../lib/store';
import { Btn, IBtn } from './kit';

// `bare`: the body brings its own .m-foot (forms that keep their state across renders)
type Modal = { title: ReactNode; sub?: ReactNode; body: ReactNode; foot?: ReactNode; size?: 'sm' | 'md' | 'lg' | 'xl' | ''; sticky?: boolean; bare?: boolean };
const modal = createStore({ m: null as Modal | null, key: 0 });
export const openModal = (m: Modal) => modal.set(s => ({ m, key: s.key + 1 }));
export const closeModal = () => modal.set({ m: null });
/** Changes the open modal's title (a wizard names each step), keeping its body and state. */
export const retitle = (title: ReactNode, sub?: ReactNode) => modal.set(s => (s.m ? { m: { ...s.m, title, sub } } : {}));

export function confirmBox(o: { title: string; body?: string; ok?: string; danger?: boolean; onOk: () => void }) {
  openModal({
    title: o.title, size: 'sm',
    body: o.body ? <p className="lead">{o.body}</p> : null,
    foot: <>
      <Btn kind="ghost" onClick={closeModal}>{L('Cancel', 'إلغاء')}</Btn>
      <Btn kind={o.danger ? 'danger' : 'primary'} onClick={() => { closeModal(); o.onOk(); }}>{o.ok || L('Confirm', 'تأكيد')}</Btn>
    </>,
  });
}

export function Layers() {
  const { m, key } = useStoreOf(modal);
  useEffect(() => {
    if (!m) return;
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape' && !m.sticky) closeModal(); };
    document.addEventListener('keydown', esc);
    const f = document.querySelector<HTMLElement>('.modal [data-autofocus], .modal .m-body input:not([type=checkbox]):not([type=radio]), .modal .m-foot .btn.primary, .modal .m-foot .btn.danger');
    f?.focus();
    return () => document.removeEventListener('keydown', esc);
  }, [m, key]);
  const box = document.getElementById('layer');
  if (!box || !m) return null;
  return createPortal(
    <>
      <div className="mscrim enter" onClick={() => { if (!m.sticky) closeModal(); }} />
      <div className={'modal ' + (m.size || '') + ' enter'} role="dialog" aria-modal="true" aria-labelledby="m-title">
        <header className="m-head"><div><h2 id="m-title">{m.title}</h2>{m.sub ? <p>{m.sub}</p> : null}</div><IBtn icon="x" title={L('Close', 'إغلاق')} onClick={closeModal} /></header>
        {m.bare ? m.body : <div className="m-body">{m.body}</div>}
        {m.foot ? <footer className="m-foot">{m.foot}</footer> : null}
      </div>
    </>,
    box,
  );
}
